<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0,3.06C0,3.06,0,12.94,0,12.94C0,12.94,4.94,8,4.94,8C4.94,8,0,3.06,0,3.06C0,3.06,0,3.06,0,3.06ZM14.94,2C14.94,2,1.06,2,1.06,2C1.06,2,8,8.940000000000001,8,8.940000000000001C8,8.940000000000001,14.94,2,14.94,2C14.94,2,14.94,2,14.94,2ZM8.53,10.53C8.39,10.67,8.21,10.75,8,10.75C7.79,10.75,7.61,10.67,7.47,10.53C7.47,10.53,6,9.059999999999999,6,9.059999999999999C6,9.059999999999999,1.06,14,1.06,14C1.06,14,14.94,14,14.94,14C14.94,14,10,9.059999999999999,10,9.059999999999999C10,9.059999999999999,8.53,10.53,8.53,10.53C8.53,10.53,8.53,10.53,8.53,10.53ZM11.06,8C11.06,8,16,12.94,16,12.94C16,12.94,16,3.06,16,3.06C16,3.06,11.06,8,11.06,8C11.06,8,11.06,8,11.06,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Envelope',
} as DefineComponent
</script>
